import(/* webpackMode: "eager" */ "/var/www/admin.dot.nyotek.com/src/app/page.tsx");
